// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rate-container {
  background-color: white;
  height: 100%;
  width: 100%;
  padding: 20px;
  overflow-y: auto;
}

.rate-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.bssid-icon {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.bssid-title {
  font-size: 24px;
  font-weight: bold;
}

.rate-section {
  margin-bottom: 20px;
}

.rate-subtitle {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.rate-text {
  font-size: 16px;
  margin-bottom: 5px;
  text-indent: 2em;
}

.rate-table {
  display: table;
  width: 100%;
  margin-bottom: 20px;
}

.table-row {
  display: table-row;
}

.table-cell {
  display: table-cell;
  padding: 5px;
  border-bottom: 1px solid #ccc;
  width: 33.33%;
}

.table-cell:first-child {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/css/BSSIDsDetailsRate.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".rate-container {\r\n  background-color: white;\r\n  height: 100%;\r\n  width: 100%;\r\n  padding: 20px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.rate-header {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.bssid-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.bssid-title {\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n}\r\n\r\n.rate-section {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.rate-subtitle {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.rate-text {\r\n  font-size: 16px;\r\n  margin-bottom: 5px;\r\n  text-indent: 2em;\r\n}\r\n\r\n.rate-table {\r\n  display: table;\r\n  width: 100%;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.table-row {\r\n  display: table-row;\r\n}\r\n\r\n.table-cell {\r\n  display: table-cell;\r\n  padding: 5px;\r\n  border-bottom: 1px solid #ccc;\r\n  width: 33.33%;\r\n}\r\n\r\n.table-cell:first-child {\r\n  font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
